import localConfig from 'mode-shared/configs/config';
import { QueryKeys } from 'mode-shared/constants/queryKeys';
import { contentfulClient } from 'mode-shared/utils';
import { useQuery } from '@tanstack/react-query';
import axios, { AxiosResponse } from 'axios';
import { WhitelistedWalletsSkeleton } from '../types';

const fetchWhitelistedWallets = async () => {
  try {
    let content = [];

    if (localConfig.showContentLive) {
      content = (
        await contentfulClient.getEntries<WhitelistedWalletsSkeleton>({
          content_type: 'aiTerminalWhitelistedWallets',
          limit: 1000,
        })
      ).items;
    } else {
      content = (
        await axios.get<void, AxiosResponse<WhitelistedWalletsSkeleton[]>>(
          `${localConfig.contentfulUrl}/aiTerminalWhitelistedWallets.json`
        )
      ).data;
    }
    return content.map((item) => item.fields.walletAddress);
  } catch (e) {
    console.error(e);
    return;
  }
};

export const useWhitelistedWallets = (options = {}) => {
  return useQuery({
    queryKey: [QueryKeys.WHITELISTED_WALLETS],
    queryFn: fetchWhitelistedWallets,
    refetchOnWindowFocus: localConfig.showContentLive,
    ...options,
  });
};
